import { IDmCoSoActionTypes } from "../../action-types/category/IDmCoSoActions";
import { ICoSoReducer } from "../../reducer-model/category/ICoSoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: ICoSoReducer = {
  status: eReducerStatusBase.is_not_initialization,
  coSos: [],
};
export const coSoReducer = (
  state: ICoSoReducer = iniState,
  action: IDmCoSoActionTypes
): ICoSoReducer => {
  switch (action.type) {
    case "CO_SO_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "CO_SO_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        coSos: action.payload,
      };
    case "CO_SO_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CO_SO_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        coSoEditing: action.payload,
      };
    case "CO_SO_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "CO_SO_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "CO_SO_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "CO_SO_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CO_SO_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "CO_SO_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "CO_SO_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
